/**
 * Hook to execute event on page to mark an issue as acknowledged. Checks if the issue is scrolled
 * into visible territory for at least N seconds as set in the element data; if so, it will fire
 * event.
 */
const AcknowledgeIssue = {
  mounted() {
    // Track if element is visible
    this.observer = new IntersectionObserver(this.callback.bind(this), {
      root: null,
      threshold: 0.9,
    });
    this.observer.observe(this.el);
  },

  destroyed() {
    this.observer.unobserve(this.el);
  },

  callback(entries) {
    const entry = entries.find(
      (element) => element.target.dataset.targetId == this.el.dataset.targetId,
    );

    if (entry && entry.isIntersecting && !this.intersectTimer) {
      // In desired number of seconds, acknowledge
      this.intersectTimer = window.setTimeout(
        this.acknowledge.bind(this),
        parseInt(this.el.dataset.acknowledgeTimeSeconds) * 1_000,
      );
    } else if (entry && !entry.isIntersecting && this.intersectTimer) {
      // Scrolled out of view before the timer, cancel timer
      window.clearTimeout(this.intersectTimer);
      this.intersectTimer = null;
    }
  },

  acknowledge() {
    // Stop observing
    this.observer.unobserve(this.el);

    // Send acknowledge event
    this.pushEvent("acknowledge-issue", { id: this.el.dataset.targetId });
  },
};

export default AcknowledgeIssue;
